export var SatisfactionSurveyStatus;
(function (SatisfactionSurveyStatus) {
    SatisfactionSurveyStatus["TO_DISPLAY"] = "TO_DISPLAY";
    SatisfactionSurveyStatus["EMAILED"] = "EMAILED";
    SatisfactionSurveyStatus["COMPLETED"] = "COMPLETED";
    SatisfactionSurveyStatus["TO_DISPLAY_IGNORED"] = "TO_DISPLAY_IGNORED";
})(SatisfactionSurveyStatus || (SatisfactionSurveyStatus = {}));
export var SatisfactionQuestionType;
(function (SatisfactionQuestionType) {
    SatisfactionQuestionType["SINGLE_CHOICE"] = "SINGLE_CHOICE";
    SatisfactionQuestionType["MULTI_CHOICE"] = "MULTI_CHOICE";
    SatisfactionQuestionType["OPEN"] = "OPEN";
})(SatisfactionQuestionType || (SatisfactionQuestionType = {}));
